import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-[#2A2B31] bg-[#0A0A0B]/95 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href="tel:0485741524"
        data-testid="mobilebar-bel"
        className="flex items-center justify-center gap-2 py-4 text-white font-display uppercase font-700 text-sm tracking-wide border-r border-[#2A2B31] active:bg-[#141518]"
      >
        <Phone size={18} className="text-[#E10600]" /> Bellen
      </a>
      <Link
        to="/afspraak"
        data-testid="mobilebar-afspraak"
        className="flex items-center justify-center gap-2 py-4 bg-[#E10600] text-white font-display uppercase font-700 text-sm tracking-wide active:bg-[#B80500]"
      >
        <CalendarCheck size={18} /> Afspraak
      </Link>
    </div>
  );
}
